// src/icons/StressIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function StressIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        clipRule: "evenodd",
        d: "M6.68674 6.27278C6.60863 6.19467 6.482 6.19467 6.4039 6.27277L1.65646 11.0202C1.34404 11.3326 0.837506 11.3326 0.525086 11.0202C0.212667 10.7078 0.212667 10.2013 0.525086 9.88884L5.27253 5.1414C5.97547 4.43846 7.11517 4.43846 7.81811 5.1414L11.8584 9.18174C11.9365 9.25984 12.0632 9.25984 12.1413 9.18174L16.1816 5.1414C16.8846 4.43846 18.0243 4.43846 18.7272 5.14141L23.4746 9.88884C23.7871 10.2013 23.7871 10.7078 23.4746 11.0202C23.1622 11.3326 22.6557 11.3326 22.3433 11.0202L17.5958 6.27278C17.5177 6.19467 17.3911 6.19467 17.313 6.27277L13.2727 10.3131C12.5697 11.0161 11.43 11.0161 10.7271 10.3131L6.68674 6.27278ZM6.68674 14.7228C6.60863 14.6447 6.482 14.6447 6.4039 14.7228L1.65646 19.4702C1.34404 19.7826 0.837505 19.7826 0.525086 19.4702C0.212667 19.1578 0.212667 18.6513 0.525086 18.3388L5.27253 13.5914C5.97547 12.8885 7.11517 12.8885 7.81811 13.5914L11.8584 17.6317C11.9365 17.7098 12.0632 17.7098 12.1413 17.6317L16.1816 13.5914C16.8846 12.8885 18.0243 12.8885 18.7272 13.5914L23.4746 18.3388C23.7871 18.6513 23.7871 19.1578 23.4746 19.4702C23.1622 19.7826 22.6557 19.7826 22.3433 19.4702L17.5958 14.7228C17.5177 14.6447 17.3911 14.6447 17.313 14.7228L13.2727 18.7631C12.5697 19.4661 11.43 19.4661 10.7271 18.7631L6.68674 14.7228Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}
export {
  StressIcon
};
//# sourceMappingURL=StressIcon.mjs.map